import React from 'react'
import { Box } from '@mui/material';
import SalesHistoryListContainer from '../../../containers/chancemng/sales-history/SalesHistoryListContainer';

const SalesHistoryTemplate = () => {
    return (
        <Box
            sx={{
                mt: 2,
            }}
        >
            <SalesHistoryListContainer />
        </Box>
    )
}

export default SalesHistoryTemplate